import React, { ReactNode } from 'react'

import { Box, Button, FormControlLabel, Radio, RadioGroup, Typography } from '@hermes/web-components'

import BaseModal from '@components/BaseModal'
import useTranslateMessage from '@hooks/useTranslateMessage'

import { ButtonContainer, Delivery, RadioFormControl, RadioLabel, Subtitle } from './ChooseDeliveryServiceModal.styles'

export enum DeliverServices {
  POSTNORD = 'postnord',
  DOORIS = 'dooris',
  HELTHJEM = 'helthjem'
}

export type ChooseDeliveryServiceData = Array<{
  value: DeliverServices
  price: number
  deliveryDays: string
  label: string
  logo: ReactNode
  description: string
}>

interface ChooseDeliveryServiceProps {
  data: ChooseDeliveryServiceData
  currentValue: DeliverServices
  isOpen: boolean
  handleClose: () => void
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  handleSubmit: () => void
}

const ChooseDeliveryServiceModal = ({
  data,
  currentValue,
  isOpen,
  handleClose,
  handleChange,
  handleSubmit
}: ChooseDeliveryServiceProps) => {
  const { t } = useTranslateMessage()

  return (
    <BaseModal isOpen={isOpen} width={438} onClose={handleClose} title={t({ id: 'chooseDelivery.title' })}>
      <Subtitle>{t({ id: 'chooseDelivery.subtitle' })}</Subtitle>
      <RadioFormControl>
        <RadioGroup value={currentValue} onChange={(e) => handleChange(e)}>
          {data.map(({ value, label, logo, description }) => (
            <Box marginBottom="24px" key={value}>
              <Box>
                <FormControlLabel id={value} name={value} value={value} control={<Radio />} label={label} />
                <RadioLabel>{description}</RadioLabel>
              </Box>
              <Delivery>
                <Typography>{t({ id: 'chooseDelivery.delivered' })}</Typography>
                {logo}
              </Delivery>
            </Box>
          ))}
        </RadioGroup>
      </RadioFormControl>
      <ButtonContainer>
        <Button sx={{ flex: 1 }} onClick={handleSubmit}>
          {t({ id: 'use' })}
        </Button>
      </ButtonContainer>
    </BaseModal>
  )
}

export default ChooseDeliveryServiceModal
